export enum HallowABFlag {
  FamilyPlanOneClickUpgrade = "family_plan_upgrade",
  WebAccountCreationScreenABC = "web_account_creation_screen_abc",
  WebAdventShortOnboarding = "web_advent_short_onboarding",
  WebAppDownloadScreen = "web_app_download_screen",
  WebFamilyPlanUpgradeAdvent = "web_family_plan_one_click_upgrade_advent",
  WebHalfOffFirstYear = "web_half_off_first_year",
  WebMediumOnboarding = "web_medium_onboarding",
  WebVariableTrialLength = "web_variable_trial_length",
  WebDOBCollection = "web_dob_collection",
  WebOnboardingSmsPrompt = "web_onboarding_sms_prompt",
  WebLentOnboarding = "web_lent_onboarding",
  WebBiggerContinueButtons = "web_bigger_continue_buttons",
  WebMissionSupporter = "web_mission_supporter",
  WebRoutines = "web_routines",
  WebNotifications = "web_notifications",
  WebKidsProfileLaunch = "web_kids_profile_launch",
  WebCostPerDayCheckout = "web_cost_per_day_checkout",
  WebXPrimer = "web_x_primer_screen",
  WebSSHomepage = "web_ss_homepage",
  WebSearchService = "web_search_service",
  WebJrEvergreenAdOnboarding = "web_jr_evergreen_ad_onboarding",
  WebDesignYourTrial = "web_design_your_trial",
}
